<template>
  <transition name="fade-out">
    <div :class="['loading-component-container', { inline }]">
      <div class="center">
        <loading-bar />
      </div>
    </div>
  </transition>
</template>

<script>
  import LoadingBar from '@components/singletons/loading-bar.vue';

  export default {
    components: {
      LoadingBar,
    },
    props: {
      inline: {
        type: Boolean,
        default: false,
      },
    },
  };
</script>

<style lang='scss' scoped>
  $loading-background-color: $white-1 !default;

  .loading-component-container {
    &:not(.inline) {
      background: $loading-background-color;
      bottom: 0;
      left: 0;
      position: absolute;
      right: 0;
      top: 0;
      z-index: 100;

      .center {
        left: 50%;
        margin: 0;
        position: absolute;
        top: 50%;
        transform: translate(-50%, -50%);
      }
    }
  }
</style>
